// axios的封装处理
import axios from "axios";
// 三个封装逻辑
// 1.根域名配置
// 2.超时时间
// 3.请求拦截器/响应拦截器      网上现成的

const request = axios.create({  //根域名配置
  baseURL: '/family/manage',//数据地址
  timeout: 7000
})

// 请求拦截器
// 在请求发送之前 做拦截 插入一些自定义的配置[参数的处理]
request.interceptors.request.use((confirm) => {
  // 对请求数据做点什么
  return confirm
}, (error) => {
  // 对请求错误做点什么
  return Promise.reject(error)
})

// 响应拦截器
// 在响应返回之到客户端之前 做拦截 重点处理返回的数据
request.interceptors.response.use((response) => {
  // 对响应数据做点什么
  return response.data
}, (error) => {
  // 对响应错误做点什么
  return Promise.reject(error)
})






// 导出实例
export { request }
export default request